// client/src/pages/admin/settings/ConstraintsSettings.js
import React from "react";

import { AttributesView } from "./AttributesView";

function AttributesSettings() {

    return (
        <div className="container-fluid">
            <div className="mb-4">
                <AttributesView />
            </div>
        </div>
    );
}

export { AttributesSettings };
